<template>
  <div v-loading="loadingInfo">
    <basic-form
      ref="stackInfo"
      title="Warehouse Info"
      :mode="FormModes.SPARSE"
      :form-params="warehouseInfo"
    >
    </basic-form>
  </div>
</template>
<script>
// others
import { FormModes } from '@/core/configs/types'
// components
import BasicForm from '@/components/common/BasicForm.vue'
// models
import { StackStatsInfoWrapUp } from '@/core/models/stack'
export default {
  name: 'StackInfo',
  components: { BasicForm },
  data() {
    return {
      FormModes,
      loadingInfo: false,
      warehouseInfo: StackStatsInfoWrapUp({
        stacksTotal: '47',
        palletsTotal: '800',
        slotsTotal: '1000',
        loadRate: '80%'
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.basic-form {
  padding-bottom: 15px;
}
</style>
